// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pgmcmeokglscggdpialy.supabase.co";
// TODO: Replace with the actual API key from your OneData prepilot project
// Get this from: https://supabase.com/dashboard/project/pgmcmeokglscggdpialy/settings/api
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBnbWNtZW9rZ2xzY2dnZHBpYWx5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUzNzMzOTUsImV4cCI6MjA3MDk0OTM5NX0.r6NTB6QATR9ffMde5MuKIePPd8kkKpqCNI3nRl5Dtfs";
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});